export const DateTimeParser = (dateTime) => {
    const date = new Date(dateTime).toLocaleDateString(navigator.language);
    const time = new Date(dateTime).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
    });

    return `${date} ${time}`;
};
